import { FC } from 'react'
import classes from './emptyState.module.scss'

interface EmptyStateProps {
  isLoading?: boolean
  message?: string
  onEnableClick?: () => void
  type?: 'disabled' | 'empty'
}

export const EmptyState: FC<EmptyStateProps> = ({
  isLoading = false,
  message = "You don't have any saved campaign.",
  onEnableClick,
  type = 'empty',
}) => {
  if (isLoading) {
    return (
      <div className={classes.emptyState}>
        <p className={classes.emptyText}>Loading review analyses...</p>
      </div>
    )
  }

  if (type === 'disabled') {
    return (
      <div className={classes.disabledContent}>
        <div className={classes.disabledBody}>
          <div className={classes.disabledIconWrapper}>
            <svg
              fill="none"
              height="32"
              viewBox="0 0 20 20"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.66699 18.3346V3.33464C1.66699 2.8763 1.83033 2.48408 2.15699 2.15797C2.48366 1.83186 2.87588 1.66852 3.33366 1.66797H16.667C17.1253 1.66797 17.5178 1.8313 17.8445 2.15797C18.1712 2.48464 18.3342 2.87686 18.3337 3.33464V13.3346C18.3337 13.793 18.1706 14.1855 17.8445 14.5121C17.5184 14.8388 17.1259 15.0019 16.667 15.0013H5.00033L1.66699 18.3346ZM7.56283 11.8763L10.0003 10.3971L12.4378 11.8763L11.792 9.10547L13.9587 7.23047L11.1045 7.0013L10.0003 4.3763L8.89616 7.0013L6.04199 7.23047L8.20866 9.10547L7.56283 11.8763Z"
                fill="black"
              />
            </svg>
          </div>
          <h2 className={classes.disabledTitle}>Review Analysis Is Disabled</h2>
          <p className={classes.disabledDescription}>
            Enable Review Analysis to evaluate customer feedback, uncover
            sentiment patterns, and identify recurring themes across reviews
            from all platforms.
          </p>
          <button
            className={classes.enableButton}
            onClick={onEnableClick}
            type="button"
          >
            Enable
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.emptyState}>
      <div className={classes.emptyIcon}>
        <svg fill="none" height="32" viewBox="0 0 24 24" width="32">
          <path
            d="M9 12H15M12 9V15M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </svg>
      </div>
      <p className={classes.emptyText}>{message}</p>
    </div>
  )
}
